// @flow
import React, {type Node} from 'react';
import {CSSTransition} from 'react-transition-group';

import './animation.scss';

type PropsType = {
    /** @ignore */
    children: Node,

    /** Animation name */
    name: string,
};

const FADE_IN = 'fadeIn';
const FADE_TOP = 'fadeTop';

export {FADE_IN, FADE_TOP};

/**
 * Product transition component
 *
 * @param {PropsType} props - component properties
 * @return {Node} rendered react component
 */
export const Animation = (props: PropsType): Node => (
    <CSSTransition {...props} classNames={props.name} timeout={100} mountOnEnter unmountOnExit>
        <div className="animationContainer">{props.children}</div>
    </CSSTransition>
);
